/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntermediaryClientRelationshipViewModel } from './IntermediaryClientRelationshipViewModel';
import {
    IntermediaryClientRelationshipViewModelFromJSON,
    IntermediaryClientRelationshipViewModelFromJSONTyped,
    IntermediaryClientRelationshipViewModelToJSON,
} from './IntermediaryClientRelationshipViewModel';

/**
 * 
 * @export
 * @interface ResultOfListOfIntermediaryClientRelationshipViewModelAllOf
 */
export interface ResultOfListOfIntermediaryClientRelationshipViewModelAllOf {
    /**
     * 
     * @type {Array<IntermediaryClientRelationshipViewModel>}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModelAllOf
     */
    data?: Array<IntermediaryClientRelationshipViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModelAllOf
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfIntermediaryClientRelationshipViewModelAllOf interface.
 */
export function instanceOfResultOfListOfIntermediaryClientRelationshipViewModelAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfIntermediaryClientRelationshipViewModelAllOfFromJSON(json: any): ResultOfListOfIntermediaryClientRelationshipViewModelAllOf {
    return ResultOfListOfIntermediaryClientRelationshipViewModelAllOfFromJSONTyped(json, false);
}

export function ResultOfListOfIntermediaryClientRelationshipViewModelAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfIntermediaryClientRelationshipViewModelAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(IntermediaryClientRelationshipViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfIntermediaryClientRelationshipViewModelAllOfToJSON(value?: ResultOfListOfIntermediaryClientRelationshipViewModelAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(IntermediaryClientRelationshipViewModelToJSON)),
        'Count': value.count,
    };
}

